import React, { Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { useContext } from "react";
import AppContext from "../../context/AppContext";
import translations from "../../components/common/Translations";
import CommonButton from "../../components/common/CommonButton";
import ModalCloseButton from "../../components/common/ModalCloseButton";

const CreateRoleModal = ({
  open,
  onClose,
  form,
  setForm,
  onSave,
  loading,
}) => {
  const { theme, langMode } = useContext(AppContext);
  const inputClass = `w-full rounded-md border px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 ${theme === "dark" ? "dark-mode" : theme === "high-contrast" ? "high-contrast" : "border-gray-300"}`;
  const labelClass = "block text-sm font-medium text-gray-700 dark:text-white mb-1";

  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog as="div" className="relative z-50" onClose={onClose}>
        <Transition.Child as={Fragment} enter="ease-out duration-300" enterFrom="opacity-0" enterTo="opacity-100" leave="ease-in duration-200" leaveFrom="opacity-100" leaveTo="opacity-0">
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75" />
        </Transition.Child>
        <div className="fixed inset-0 z-50 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-2 sm:p-4">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel className={`relative flex max-h-[calc(100dvh-1rem)] w-full flex-col overflow-hidden rounded-xl bg-white shadow-xl sm:max-w-lg sm:rounded-2xl ${theme === "dark" ? "dark-mode" : theme === "high-contrast" ? "high-contrast" : ""}`}>
                <div className="flex items-center justify-between border-b border-gray-200 px-3 py-3 sm:px-5 sm:py-4">
                  <Dialog.Title className="min-w-0 truncate text-base font-semibold sm:text-lg">{translations[langMode].createRole}</Dialog.Title>
                  <ModalCloseButton onClick={onClose} />
                </div>
                <div className="min-h-0 space-y-4 overflow-y-auto px-3 py-4 sm:px-5 sm:py-6">
                 
                  <div>
                    <label className={labelClass}>{translations[langMode].roleName}</label>
                    <input
                      type="text"
                      value={form.roleName}
                      onChange={(e) => setForm((f) => ({ ...f, roleName: e.target.value }))}
                      placeholder={translations[langMode].roleName}
                      className={inputClass}
                    />
                  </div>
                  <div>
                    <label className={labelClass}>{translations[langMode].description}</label>
                    <textarea
                      value={form.description}
                      onChange={(e) => setForm((f) => ({ ...f, description: e.target.value }))}
                      placeholder={translations[langMode].description}
                      className={inputClass}
                      rows={3}
                    />
                  </div>
                </div>
                <div className="flex flex-wrap items-center justify-end gap-2 border-t border-gray-200 px-3 py-3 sm:gap-3 sm:px-5 sm:py-4">
                  <CommonButton colorIntent="danger" variant="danger" onClick={onClose}>{translations[langMode].cancle || "Cancel"}</CommonButton>
                  <CommonButton colorIntent="success" variant="primary" onClick={onSave} disabled={loading}>{translations[langMode].save}</CommonButton>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
};

export default CreateRoleModal;
